import script from "./Route.vue?vue&type=script&setup=true&lang=js"
export * from "./Route.vue?vue&type=script&setup=true&lang=js"

import "./Route.vue?vue&type=style&index=0&id=33df5c45&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33df5c45"]])

export default __exports__